import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from './assets/img/img.png'
import _imports_1 from './assets/img/FigmaDDSSlicePNGb26d265b3a4e9d0511811df76e1a157a.png'


const _hoisted_1 = { class: "landing-page" }
const _hoisted_2 = { class: "glass-navbar" }
const _hoisted_3 = { class: "nav-container" }
const _hoisted_4 = { class: "nav-links" }
const _hoisted_5 = { class: "nav-actions" }
const _hoisted_6 = {
  class: "icon-action-btn",
  title: "切换语言"
}
const _hoisted_7 = { class: "avatar-wrapper" }
const _hoisted_8 = { class: "user-name" }
const _hoisted_9 = { class: "hero-section" }
const _hoisted_10 = { class: "hero-content" }
const _hoisted_11 = { class: "hero-cta-group" }
const _hoisted_12 = {
  class: "features-section",
  id: "features"
}
const _hoisted_13 = { class: "bento-grid" }
const _hoisted_14 = { class: "bento-card bento-wide" }
const _hoisted_15 = { class: "card-text" }
const _hoisted_16 = { class: "card-icon" }
const _hoisted_17 = { class: "card-visual visual-map" }
const _hoisted_18 = { class: "mock-pin" }
const _hoisted_19 = { class: "bento-card" }
const _hoisted_20 = { class: "card-text" }
const _hoisted_21 = { class: "card-icon" }
const _hoisted_22 = { class: "bento-card" }
const _hoisted_23 = { class: "card-text" }
const _hoisted_24 = { class: "card-icon" }
const _hoisted_25 = { class: "bento-card bento-wide" }
const _hoisted_26 = { class: "card-text" }
const _hoisted_27 = { class: "card-icon" }
const _hoisted_28 = {
  class: "preview-showcase-section",
  id: "app-download"
}
const _hoisted_29 = { class: "showcase-box" }
const _hoisted_30 = { class: "showcase-left" }
const _hoisted_31 = {
  class: "store-buttons",
  style: {"display":"flex","justify-content":"space-around"}
}
const _hoisted_32 = {
  href: "https://www.pgyer.com/RPenmbNb",
  target: "_blank",
  class: "download-link-card"
}
const _hoisted_33 = {
  href: "https://apps.apple.com/cn/app/mapgame/id6740665605",
  target: "_blank",
  class: "download-link-card"
}
const _hoisted_34 = { class: "site-footer" }
const _hoisted_35 = { class: "footer-container" }
const _hoisted_36 = { class: "footer-links-group" }
const _hoisted_37 = { class: "link-col" }
const _hoisted_38 = { class: "link-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Document = _resolveComponent("Document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_FolderOpened = _resolveComponent("FolderOpened")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_VideoPlay = _resolveComponent("VideoPlay")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_LocationInformation = _resolveComponent("LocationInformation")!
  const _component_LocationFilled = _resolveComponent("LocationFilled")!
  const _component_Aim = _resolveComponent("Aim")!
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_Medal = _resolveComponent("Medal")!
  const _component_Iphone = _resolveComponent("Iphone")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[48] || (_cache[48] = _createElementVNode("div", { class: "ambient-glow glow-top-left" }, null, -1)),
    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "ambient-glow glow-top-right" }, null, -1)),
    _cache[50] || (_cache[50] = _createElementVNode("div", { class: "ambient-glow glow-middle" }, null, -1)),
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "brand-logo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
        }, [...(_cache[17] || (_cache[17] = [
          _createStaticVNode("<div class=\"logo-badge\" data-v-595da915><img src=\"" + _imports_0 + "\" alt=\"\" style=\"width:100%;height:100%;\" data-v-595da915></div><div class=\"brand-text\" data-v-595da915><span class=\"main-title\" data-v-595da915>BAGL</span><span class=\"sub-title\" data-v-595da915>Creator Studio</span></div>", 2)
        ]))]),
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("a", {
            class: "nav-item",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.scrollToSection('features')), ["prevent"]))
          }, "核心特性"),
          _createElementVNode("a", {
            class: "nav-item",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.scrollToSection('showcase')), ["prevent"]))
          }, "玩法矩阵"),
          _createElementVNode("a", {
            class: "nav-item",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.scrollToSection('app-download')), ["prevent"]))
          }, "移动端 App"),
          _createElementVNode("a", {
            class: "nav-item",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openAbout && _ctx.openAbout(...args)), ["prevent"]))
          }, "关于我们")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_dropdown, {
            trigger: "click",
            onCommand: _ctx.handleCommand,
            class: "lang-dropdown"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, { class: "custom-dropdown-menu" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, { command: "cn" }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createTextVNode("简体中文", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_dropdown_item, { command: "jp" }, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createTextVNode("繁体中文", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_dropdown_item, { command: "en" }, {
                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                      _createTextVNode("English", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("button", _hoisted_6, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Document)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["onCommand"]),
          (_ctx.isLogin)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "create-btn",
                  onClick: _ctx.CreateGame
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }),
                    _cache[21] || (_cache[21] = _createElementVNode("span", null, "创作新游戏", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_dropdown, {
                  trigger: "click",
                  class: "user-dropdown"
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, { class: "custom-dropdown-menu" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/list')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_FolderOpened)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.list") || "游戏作品库"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/setting')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Setting)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.Setting") || "个人与系统设置"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, {
                          divided: "",
                          onClick: _ctx.logout,
                          class: "danger-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_SwitchButton)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.logout") || "退出登录"), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_el_avatar, {
                        src: _ctx.userInfo?.avatar,
                        size: 38,
                        class: "user-avatar"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.userInfo?.name ? _ctx.userInfo.name.charAt(0) : "U"), 1)
                        ]),
                        _: 1
                      }, 8, ["src"]),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.userInfo?.name || "创作者"), 1)
                    ])
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_el_button, {
                  class: "login-text-btn",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/login')))
                }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode(" 登录 ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "join-btn",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push('/login')))
                }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode(" 免费注册入驻 ", -1)
                  ]))]),
                  _: 1
                })
              ], 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[25] || (_cache[25] = _createStaticVNode("<div class=\"hero-pill-badge\" data-v-595da915><span class=\"pulse-dot\" data-v-595da915></span><span data-v-595da915>新一代现实增强实景探索创作引擎</span></div><h1 class=\"hero-title\" data-v-595da915> 将整座城市与自然景区<br data-v-595da915> 变成你笔下的<span class=\"gradient-text\" data-v-595da915>沉浸式解谜游戏</span></h1><p class=\"hero-description\" data-v-595da915> 免写代码、可视化编排真实地理坐标、AR 识别图像、分步剧情线索与多角色羁绊。面向文旅景区、城市探索团队与剧本创作者的专业级 SaaS 工具。 </p>", 3)),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "large",
            class: "hero-primary-btn",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isLogin ? _ctx.CreateGame() : _ctx.$router.push('/login')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_VideoPlay)
                ]),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.isLogin ? "进入创作者工作台" : "立即开始创作"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            size: "large",
            class: "hero-secondary-btn",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.scrollToSection('features')))
          }, {
            default: _withCtx(() => [
              _cache[24] || (_cache[24] = _createElementVNode("span", null, "了解平台功能", -1)),
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ArrowDown)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _cache[26] || (_cache[26] = _createStaticVNode("<div class=\"partner-strip\" data-v-595da915><span class=\"strip-label\" data-v-595da915>赋能多样化落地场景</span><div class=\"partner-logos\" data-v-595da915><span class=\"partner-chip\" data-v-595da915>城市漫游 (City Walk)</span><span class=\"partner-chip\" data-v-595da915>实景沉浸剧本游</span><span class=\"partner-chip\" data-v-595da915>景区研学互动导览</span><span class=\"partner-chip\" data-v-595da915>AR 寻宝打卡展演</span></div></div>", 1))
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "section-heading" }, [
        _createElementVNode("span", { class: "subhead" }, "CORE CAPABILITIES"),
        _createElementVNode("h2", { class: "head-title" }, "为什么选择 BAGL Creator Studio"),
        _createElementVNode("p", { class: "head-desc" }, " 为创作者抹平技术门槛，将创意直接转化为手机端可游玩的户外实景体验 ")
      ], -1)),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_LocationInformation)
            ]),
            _cache[27] || (_cache[27] = _createElementVNode("h3", null, "高德地图 / 自定义手绘底图无缝支持", -1)),
            _cache[28] || (_cache[28] = _createElementVNode("p", null, " 精确绑定经纬度或使用手绘园区地图坐标，支持电子围栏判定与玩家越界位置提示。 ", -1))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_LocationFilled)
                ]),
                _: 1
              }),
              _cache[29] || (_cache[29] = _createElementVNode("span", null, "打卡关卡点 A", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_Aim)
            ]),
            _cache[30] || (_cache[30] = _createElementVNode("h3", null, "实景图像扫描识别", -1)),
            _cache[31] || (_cache[31] = _createElementVNode("p", null, " 通过手机摄像头比对现实地标、雕塑与海报纹理，解开实体场景机关。 ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_UserFilled)
            ]),
            _cache[32] || (_cache[32] = _createElementVNode("h3", null, "多角色分工与独立线索", -1)),
            _cache[33] || (_cache[33] = _createElementVNode("p", null, "支持为不同职业分配专属技能与私密线索，促成团队深度分工协作。", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_Medal)
            ]),
            _cache[34] || (_cache[34] = _createElementVNode("h3", null, "自动化梯度提示与动态积分", -1)),
            _cache[35] || (_cache[35] = _createElementVNode("p", null, " 配置超时扣分、提示惩处与通关时间系数，系统自动统计排行榜与胜负结算。 ", -1))
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "card-visual visual-score" }, [
            _createElementVNode("div", { class: "score-pill-show" }, [
              _createElementVNode("span", { class: "sp-label" }, "综合得分上限"),
              _createElementVNode("span", { class: "sp-num" }, "1,500 PTS")
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _cache[40] || (_cache[40] = _createElementVNode("span", { class: "badge-tag" }, "MOBILE COMPANION", -1)),
          _cache[41] || (_cache[41] = _createElementVNode("h2", null, [
            _createTextVNode("手机端实景游玩 App"),
            _createElementVNode("br"),
            _createTextVNode("玩家一键入局探索")
          ], -1)),
          _cache[42] || (_cache[42] = _createElementVNode("p", null, " 后台发布的游戏直接同步至玩家移动终端。支持离线数据包、AR 实景相机渲染、高精度路线打卡与终局复盘。 ", -1)),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("a", _hoisted_32, [
              _createVNode(_component_el_icon, { class: "dl-icon" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Iphone)
                ]),
                _: 1
              }),
              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "dl-info" }, [
                _createElementVNode("span", { class: "dl-sub" }, "Download for"),
                _createElementVNode("span", { class: "dl-main" }, "Android")
              ], -1))
            ]),
            _createElementVNode("a", _hoisted_33, [
              _createVNode(_component_el_icon, { class: "dl-icon" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Iphone)
                ]),
                _: 1
              }),
              _cache[39] || (_cache[39] = _createElementVNode("div", { class: "dl-info" }, [
                _createElementVNode("span", { class: "dl-sub" }, "Download for"),
                _createElementVNode("span", { class: "dl-main" }, "IOS")
              ], -1))
            ])
          ])
        ]),
        _cache[43] || (_cache[43] = _createStaticVNode("<div class=\"showcase-right\" data-v-595da915><div class=\"mockup-phone\" data-v-595da915><div class=\"phone-top-bar\" data-v-595da915><div class=\"notch\" data-v-595da915></div></div><div class=\"phone-screen\" data-v-595da915><div class=\"app-mock-nav\" data-v-595da915><span data-v-595da915>实景关卡 · 城市漫游</span></div><div class=\"app-mock-hero\" data-v-595da915><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:100%;position:absolute;left:0;\" data-v-595da915><div class=\"hero-floating-badge\" data-v-595da915>第 3 关 / 共 6 关</div></div><div class=\"app-mock-body\" data-v-595da915><h4 data-v-595da915>寻找古戏台石狮印记</h4><p data-v-595da915> 根据指南针指引前往坐标点，找到刻有暗号的石柱并使用相机对准扫描。 </p><div class=\"app-mock-chip-row\" data-v-595da915><span class=\"app-chip\" data-v-595da915>难度 ★★★☆☆</span><span class=\"app-chip\" data-v-595da915>限时 15 分钟</span></div></div><div class=\"app-mock-footer\" data-v-595da915><button class=\"mock-action-btn\" data-v-595da915>开启 AR 扫描</button></div></div></div></div>", 1))
      ])
    ]),
    _createElementVNode("footer", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _cache[46] || (_cache[46] = _createStaticVNode("<div class=\"footer-brand\" data-v-595da915><div class=\"brand-logo\" data-v-595da915><div class=\"logo-badge\" data-v-595da915><img src=\"" + _imports_0 + "\" alt=\"\" style=\"width:100%;height:100%;\" data-v-595da915></div><span class=\"main-title\" data-v-595da915>BAGL Studio</span></div><p class=\"footer-motto\" data-v-595da915>赋予实体空间以故事与灵魂的世界构建工具。</p></div>", 1)),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _cache[44] || (_cache[44] = _createElementVNode("span", { class: "col-title" }, "产品功能", -1)),
            _createElementVNode("a", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.scrollToSection('features')))
            }, "关卡设计器"),
            _createElementVNode("a", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.scrollToSection('features')))
            }, "AR 识别引擎"),
            _createElementVNode("a", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.scrollToSection('features')))
            }, "积分规则中心")
          ]),
          _createElementVNode("div", _hoisted_38, [
            _cache[45] || (_cache[45] = _createElementVNode("span", { class: "col-title" }, "创作者中心", -1)),
            _createElementVNode("a", {
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.CreateGame && _ctx.CreateGame(...args)))
            }, "发布作品"),
            _createElementVNode("a", {
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$router.push('/list')))
            }, "我的游戏库"),
            _createElementVNode("a", {
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.openAbout && _ctx.openAbout(...args)))
            }, "开放协议")
          ])
        ])
      ]),
      _cache[47] || (_cache[47] = _createElementVNode("div", { class: "footer-bottom" }, [
        _createElementVNode("p", null, "© 2026 BAGL Creator Platform. All rights reserved."),
        _createElementVNode("span", { class: "tech-tag" }, "Powered by Vue 3 & Modern SaaS Stack")
      ], -1))
    ])
  ]))
}